import { render, staticRenderFns } from "./report-wen.vue?vue&type=template&id=7bf2c2ac&scoped=true"
import script from "./report-wen.vue?vue&type=script&lang=ts"
export * from "./report-wen.vue?vue&type=script&lang=ts"
import style0 from "./report-wen.vue?vue&type=style&index=0&id=7bf2c2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf2c2ac",
  null
  
)

export default component.exports